import { createFieldset } from './fieldset';

export default {
  title: 'Crea Transazione',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'bowl-transactions',
            method: 'POST'
          }
        },
        fieldsets: [createFieldset]
      }
    }
  ]
};
